import { ProductData } from '@/api';
import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import IconPicture from '@/icons/Picture.svg';
import { ProductFromGetMany } from '@/models/product';
import { createBEMClasses } from '@/utils/classname';

import './ProductSearchSelect.css';

const { element } = createBEMClasses('product-search-select');

export const ProductSearchSelectReference = ({
  product,
  image,
}: {
  product: ProductFromGetMany;
  image?: boolean;
}) => {
  return (
    <Stack row gap="0.5rem" flexWrap="nowrap" alignItems="center">
      {image && <ProductSearchSelectImage product={product} />}
      {getDesignExternalIdNameCollection(product)}
    </Stack>
  );
};

const ProductSearchSelectImage = ({ product }: { product: ProductFromGetMany }) => {
  return product.data.image ? (
    <img alt={product.name} src={product.data.image} className={element('img')} />
  ) : (
    <div className={element('img-placeholder')}>
      <IconPicture className="text-disabled" />
    </div>
  );
};

const getDesignExternalIdNameCollection = (product: {
  externalId: string;
  name: string;
  data: ProductData;
}) => {
  return (
    <Stack>
      <InlineText weight="regular" color="primary">
        {product.externalId}
      </InlineText>
      {product.name !== product.externalId && product.data.collection ? (
        <InlineText size="200" color="secondary">
          {product.name} ({product.data.collection})
        </InlineText>
      ) : product.name !== product.externalId ? (
        <InlineText size="200" color="secondary">
          {product.name}
        </InlineText>
      ) : product.data.collection ? (
        <InlineText size="200" color="secondary">
          ({product.data.collection})
        </InlineText>
      ) : null}
    </Stack>
  );
};
